import React from 'react';
import { Create, useNotify, useRedirect } from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import PricingRulesForm from './PricingRulesForm';

const RESOURCE_NAME = 'resale/pricing';

const PricingRulesCreate = () => {
  const { title } = useTitle('Create Pricing Rule');
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Create
      title={title}
      mutationOptions={{
        onSuccess: () => {
          notify('Pricing rule created successfully', { type: 'success' });
          redirect('list', RESOURCE_NAME);
        },
        onError: (error: unknown) => {
          const message = error instanceof Error ? error.message : 'Failed to create pricing rule';
          notify(`Error: ${message}`, { type: 'error' });
        },
      }}
    >
      <PricingRulesForm />
    </Create>
  );
};

export default PricingRulesCreate;
